import IssuePreview from "./IssuePreview";

export default IssuePreview;
